var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop } from "vue-facing-decorator";
let StatusOverlayComponent = class StatusOverlayComponent extends Vue {
    created() {
    }
    ;
    toggle() {
        this.visible = !this.visible;
    }
    ;
    get cssClass() {
        return this.visible ? `active` : ``;
    }
    ;
    get text() {
        return this.message || '';
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], StatusOverlayComponent.prototype, "visible", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], StatusOverlayComponent.prototype, "message", void 0);
StatusOverlayComponent = __decorate([
    Component({
        name: "StatusOverlayComponent"
    })
], StatusOverlayComponent);
export default StatusOverlayComponent;
